import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./notificationcard.module.css";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Mail, Send } from "react-feather";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { TableLoader } from "../../../../../../components/LoaderC";

const NotificationCard = ({ item, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [panel, setPanel] = useState("");
    const [emailBody, setEmailBody] = useState("");
    const [contentLoading, setContentLoading] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setPanel(isExpanded ? panel : false);

        if (emailBody === "" && isExpanded) {
            getNotificationBody();
        }
    }

    const getNotificationBody = async () => {
        setContentLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/email-body/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setContentLoading(false);
            setEmailBody(response.data.data);
        }).catch((error) => {
            setContentLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const resendBtn = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/resend-mail/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return <Accordion expanded={panel === "panel"} onChange={handleChange("panel")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <div className={`${styles.NotesCard2}`}>
                <div className={`${styles.AlertCardFirstSec}`}>
                    <div className={`${styles.AccoTitleHead} ${styles.Notification}`}>
                        <div className={`${styles.CardStatusSec}`}>
                            <p className={`${styles.DateInfoAcc}`}>
                                <Mail />
                                <div>
                                    <p className={`${styles.DueOnBadge}`}>{item?.subject}</p>
                                    <p className={`${styles.BadgeDate}`}>{dayjs(item?.sent_at).format('MMMM D, YYYY')}</p>
                                </div>
                            </p>
                        </div>
                        <div className={`${styles.CardAmountSec}`}>
                            <div>
                                <p className={`${styles.DateInfo}`}><span>Category:</span> {item?.category}</p>
                            </div>
                            <div>
                                <p className={`${styles.DateInfo}`}><span>Type:</span> Email</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            {contentLoading && (<div className="Loader TableLoader">
                <TableLoader />
            </div>)}
            <button className={`${styles.ResendNotiBU}`} onClick={(e) => resendBtn()}><Send /> Resend</button>
            {!contentLoading && <div dangerouslySetInnerHTML={{ __html: emailBody }}></div>}
        </AccordionDetails>
    </Accordion>;
}

export default NotificationCard;